export function jsonToCss(json: { [key: string]: string }) {
  return Object.keys(json)
    .map(key => `${key}:${json[key]}`)
    .join(";")
}

function decodeHTMLEntities(text) {
  const doc = new DOMParser().parseFromString(text, "text/html")
  return doc.documentElement.textContent || ""
}

export function cssToJson(css: string) {
  const newCss = decodeHTMLEntities(css)
  const json: { [key: string]: string } = {}
  const rules = newCss.split(";").filter(rule => rule.trim() !== "")
  rules.forEach(rule => {
    const arr = rule.split(":")
    if (arr.length < 2) return
    const property = arr.shift()!.trim()
    json[property] = arr.join(":").trim()
  })
  return json
}
